/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { styled } from 'fierry/react';

import BorderCenter from 'solis/react/board/hex/border.center';


const Dot = styled.circle`
  fill: var(--accent-11);
`;


const getDotProps = ({ hexGeometry }, offset) =>
{
  return { cx: hexGeometry.getExternalWidth(0.15), cy: hexGeometry.getExternalSize(offset), r: hexGeometry.getExternalSize(0.04) };
};


const getOffsets = (value) =>
{
  // Dense variant
  return [ 0.15, 0, - 0.15 ].slice(0, value);

  // Sparse variant
  //return [ 0.2, 0, - 0.2 ].slice(0, value);
};


const Component = ({ value, ...props }) =>
(
  getOffsets(value).map(offset => <Dot key = {offset} {...props} {...getDotProps(props, offset)} />)
);


export default (props) =>
{
  const { value, zoneData, hexGeometry, selected } = props;

  if (selected || !value || zoneData.isEstablished() || !hexGeometry.isEntityVisible())
  {
    return null;
  }

  return <BorderCenter {...props} Component = {Component} index = {1} />;
};
